import script from "./DataTableHtml.vue?vue&type=script&setup=true&lang=js"
export * from "./DataTableHtml.vue?vue&type=script&setup=true&lang=js"

import "./DataTableHtml.vue?vue&type=style&index=0&id=a627a206&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a627a206"]])

export default __exports__